let hubspot = (window._hsq = window._hsq || []);

const AnalyticsHubspotHandler = (function () {
  const instance = {};

  instance.identify = email => {
    hubspot.push(['identify', {email: email}]);
  };
  instance.trackPageView = path => {
    hubspot.push(['setPath', path]);
    hubspot.push(['trackPageView']);
  };

  return instance;
})();

export default AnalyticsHubspotHandler;
